export const wrapperInventoryControl = {
	titleWrapper: "Create new inventory",
	titleButtons: {
		sendInventory: "Send inventory",
		approveInventory: "Approve inventory",
		retellInventory: "retell",
		downloadInExcel: "Download in excel",
	},
	reopenModal: {
		title: "Recount inventory",
		body:
			"Once recounted, the inventory goes back to the stockist with the justification provided.",
		reasonLabel: "Justification",
		reasonPlaceholder: "Write the reason for the recount",
		reasonRequired: "Enter the justification",
		reasonMaxLength: "The justification must be at most {{maxLength}} characters",
		confirm: "Recount",
		cancel: "Cancel",
	},
	placeholders: {
		keywordSearch: "Search by category, code or product",
	},
	headerInfos: {
		name: "Name",
		inventoryTitle: "Inventory title",
		createAt: "Creation date",
		lastEdtion: "Last edition",
		detailsInventory: "Inventory details",
		stockist: "Stockist",
		totalProducts: "Total products",
		categoriesSelected: "Selected categories",
		storageSelected: "Storage selected",
		storageAndCategoriesSelected: "Storage and categories",
		status: "Status",
	},
	seeMoreDetails: "See more details",
	drawerInfos: {
		seeDetails: "See details",
	},
};
